import './App.css';

const FAQ_DATA = [
  {
    title: 'General',
    items: [
      {
        q: 'Is Noorvia free to use?',
        a: "Yes! Noorvia is free with full access to prayer times, Qibla compass, Quran reading, dhikr counter, duas, hadith, and more. One optional subscription — Noorvia Gold — unlocks additional customization and tracking features.",
      },
      {
        q: 'Does Noorvia work offline?',
        a: 'Prayer times, Qibla direction, dhikr counter, duas, and most features work offline once loaded. Quran audio streaming and hadith downloads require an internet connection.',
      },
      {
        q: 'How accurate are the prayer times?',
        a: 'Noorvia uses established astronomical calculation methods (such as ISNA, MWL, and Umm Al-Qura) based on your location. You can choose the calculation method that matches your local mosque or community in Settings.',
      },
    ],
  },
  {
    title: 'Noorvia Gold',
    items: [
      {
        q: 'What does Noorvia Gold include?',
        a: 'Noorvia Gold unlocks everything — all logging and tracking features (prayer logs, Quran tracking, fasting tracker, zakat tracker, sunnah tracking, dhikr insights, spiritual checklist with achievements, and analytics) plus the full personalization suite (additional accent colors, prayer card marble styles, countdown skins, icon animations, border effects, Qibla compass styles, and hadith folder colors).',
      },
      {
        q: 'How much does Noorvia Gold cost?',
        a: 'Noorvia Gold is $2.99 per month. It renews automatically until you cancel.',
      },
      {
        q: 'How do I cancel my subscription?',
        a: 'Open the Settings app on your iPhone, tap your name, then Subscriptions, and select Noorvia. Cancel at least 24 hours before your renewal date to avoid being charged for the next period. You keep Gold features until the end of the current billing period.',
      },
      {
        q: 'How do I restore my subscription on a new device?',
        a: 'Go to the Shop page and tap "Restore Purchases." Your subscription is tied to your Apple ID and will restore automatically.',
      },
    ],
  },
  {
    title: 'Privacy & Data',
    items: [
      {
        q: 'Does Noorvia collect my personal data?',
        a: 'Noorvia does not collect, sell, or share any personal data. Your prayer logs, settings, and spiritual data stay on your device and sync privately through your iCloud account.',
      },
      {
        q: 'How does iCloud sync work?',
        a: 'Your data syncs across all devices signed into the same Apple ID via iCloud. This happens automatically — no account creation required.',
      },
      {
        q: 'Does Noorvia track my location?',
        a: 'Noorvia only uses your location to calculate accurate prayer times and Qibla direction. Your location is never sent to external servers or stored.',
      },
    ],
  },
  {
    title: 'Features',
    items: [
      {
        q: "How do I change the app's accent color or theme?",
        a: 'Go to Settings and choose your preferred accent color. Additional colors are available with Noorvia Gold.',
      },
      {
        q: 'Can I customize which widgets appear on my home screen?',
        a: 'Yes! Tap the customize button on the home screen to show, hide, and reorder widgets like the Islamic date, verse of the day, sunnah banner, and more.',
      },
      {
        q: 'How does the Qibla compass work?',
        a: "The Qibla compass uses your device's GPS and magnetometer to point toward the Kaaba in Makkah. For best accuracy, calibrate your compass by moving your phone in a figure-8 motion.",
      },
      {
        q: 'What Quran translations and reciters are available?',
        a: 'Noorvia offers multiple translations and a wide selection of reciters for audio playback, powered by the Quran Foundation API.',
      },
    ],
  },
  {
    title: 'Troubleshooting',
    items: [
      {
        q: 'My prayer times seem incorrect. What should I do?',
        a: 'Check that your location permissions are enabled and that the correct calculation method is selected in Settings. Different methods can vary by a few minutes.',
      },
      {
        q: "Notifications aren't working. How do I fix this?",
        a: "Make sure notifications are enabled in both Noorvia's settings and your iPhone's Settings > Notifications > Noorvia. Also check that Do Not Disturb or Focus modes aren't blocking them.",
      },
      {
        q: "My purchases aren't showing after reinstalling.",
        a: "Go to the Shop page and tap \"Restore Purchases.\" If the issue persists, make sure you're signed into the same Apple ID used for the original purchase.",
      },
    ],
  },
];

function SupportPage() {
  return (
    <main className="prose-page">
      <header className="prose-head">
        <span className="eyebrow">Support</span>
        <h1 className="prose-title">
          Help &amp; <span className="gradient-text">FAQ</span>
        </h1>
        <p className="prose-meta">Got a question? You're in the right place.</p>
      </header>

      <section className="support-contact">
        <h2>Contact us</h2>
        <p>
          For questions, feedback, or bug reports, email us directly. We aim to
          respond within a few days.
        </p>
        <a
          href="mailto:noorviasupport@gmail.com"
          className="support-email"
        >
          noorviasupport@gmail.com
        </a>
      </section>

      <section className="support-patreon">
        <div>
          <h2>Support development</h2>
          <p>
            Noorvia is built and maintained by one person. If the app has been
            meaningful to you, consider becoming a patron — it directly funds
            new features and keeps Noorvia free of ads and tracking.
          </p>
        </div>
        <a
          href="https://www.patreon.com/c/MukuwaBaffoe"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Become a patron
        </a>
      </section>

      <article className="prose">
        {FAQ_DATA.map((category) => (
          <section key={category.title}>
            <h2>{category.title}</h2>
            <div className="faq-list">
              {category.items.map((item) => (
                <details key={item.q} className="faq-item">
                  <summary>
                    <span>{item.q}</span>
                    <span className="faq-chevron" aria-hidden="true" />
                  </summary>
                  <p>{item.a}</p>
                </details>
              ))}
            </div>
          </section>
        ))}
      </article>
    </main>
  );
}

export default SupportPage;
